import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subject, BehaviorSubject, Subscription, of } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import {PdfprintService} from './pdfprint.service';
import { CommerrorService } from './commerror.service';
import { SignatureService } from './signature.service';
import { Exam } from "./interfaces/exams.service/types";
import { SupportCenterService } from './support-center/support-center.service';

// The API's answer when a 2FA code could not be sent (cardioaweb-api utils/twofa.js).
interface TwoFaSendFailure {
  status: 'fail';
  twofaSendFailed: true;
  attemptedMethod: 'sms' | 'whatsapp';
  alternateMethod: 'sms' | 'whatsapp';
  error: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  contLogin = false;
  username: string;
  limits;
  public premissions = null;
  totpVerify =false;
  public invasiveExams = false;
  UID;
  linksent;
  base64;
  clinicUsers;
  public loggedIn = false;
  loginError: string;
  getCode = false;
  lastAwl:string;
  lastAwlExam:string;
  lastAwlStartDate:any;
  lastAwlEnDate:any;
  export$ = new Subject<any>()
  exportLoading = false;
  ENVLoaded = new Subject();
  rooms
  public category = {
    name: "doctor",
    canOpen: {
      form:true,
      exam:true
    },
    canCreate:{
      form:true,
      exam:true
    },
    canChange:{
      form:true,
      exam:true
    },
    canSend: {
      form:true,
      exam:true
    },
    todayList: true
  };
  public hastech = false;
  public Recording: string;
  public RemoteRTC = false;
  public hasAWL = false;
  public AWLUnlimited = false;
  public bitRate = 500000;
  public highBit = 3000000;
  public AWLOnlyExams = false;
  public onLogin: Subject<null>;
  public onLoginComplete: Subject<null>;
  // Fired with the tab key whenever the exam tab bar switches pages —
  // consumed by AnnouncementHostComponent for trigger:'tab' bubbles.
  public tabChanged$: Subject<string> = new Subject<string>();
  public onFailedLogin: Subject<null>
  public canOpenExams: boolean;
  public fullDelivery: string = 'download';
  public printLang: string = null;
  public printStyle: string = null;
  public userType = 'doctor';
  public room=null
  public summaryOnlyAnamolies = false;
  archiveServer: string;
  loginname:string;
  public printAllMeas = true
  public dopplerAutoOk = true;
  public RequireLoginToOpen = false;
  public anatomyAltNames;
  public hasChameleon = true;
  public hasFollicles=true;
  public defaultsButton = false;
  public links = true;
  public Clinic: string;
  public ClinicID:number;
  public localServer = false;
  public letterhead=false;
  location: string;
  public VideoCodec = 'video/webm;codecs=vp9';
  public clinicOptions;
  public filteredClinicSearch: [] = [];  
  public isArtisanSupport = false;
  // Support Center kill switch, sent by the API in env (SSM supportCenter.enabled)
  public supportCenterEnabled = false;
  // True only once a login has completed (clinic chosen; for Artisan support, the user too) - the
  // Support Center widget waits for it, so it never appears over the pickers.
  public loginComplete = false;
  public usersList: any[] = [];
  public filteredUserSearch: any[] = [];
  public ishospital:any = false;
  public hasLeumit = false;
  public isCardio=false;
  public isGastro=false;
  public PRNcheck = true;
  public requireExamLogon = true;
  public AWLExamNames = false;
  public hasEmergencyRoom = false;
  public altArchiveName:string = null;
  public CustomHeader = new UntypedFormControl(false)
  picAlt="Header Pic"
  headerToShow;
  isImageLoading = false;
  public altSplashPage;
  // The API's version (its package.json), sent at login and shown in the About popup.
  public APIversion: string;
  public isAdmin= false;
  public noneAsMeasDefault = false;
  public LeumitAdmin = false;
  public barcodeScan = false;
  public ExamCodes;
  public hasENV = false;
  public doctor = null;
  public PeerServ: {host: string, port: number, path: string};
  public separatedClinic = false;
  public SeparateZimun = false;
  public officeServer = false;
  public maccabiExams:any[] = null;
  // clinics Maccabi gave more than one unit code (e.g. pulmonary and EMG)
  public macabiUnits: {code: string, desc: string}[] = null;
  public finances = false;

  private sessionExpiration = new BehaviorSubject<string>('');
  private sessionExpirationSubscription: Subscription;
  private timeoutId: any;
  private cachedCredentials: { user: string, pw: string, location?: string } | null = null;
  // 2FA send-failure UX: the channel to offer next (null once every channel has been tried,
  // and the message points at support instead of a button).
  twoFaAlternateMethod: 'sms' | 'whatsapp' | null = null;
  private triedTwoFaMethods = new Set<string>();
  public showTwoFactorInput = false;
  public twoFactorRequired = new Subject<void>();
  public updateInfoRequired = new Subject<void>();
  public isLoginLoading: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private sanitization: DomSanitizer,
    private pdf: PdfprintService,
    private commerrorService: CommerrorService,
    private signatureService: SignatureService,
    private sc: SupportCenterService,
  ) {
      this.onLogin= new Subject();
      this.onLogin.subscribe(() => (this.loginComplete = true));
      this.onLoginComplete = new Subject();
      this.onFailedLogin = new Subject();
      this.http.get('/api/getenv').subscribe((data)=>{
        let p = {};
        p['env'] = data;
        this.setEnv(p);  
      },(error)=> { 
        console.log(error);
      })
   }

async login(user: string, pw: string, navigate = true, exam = false, isexport = false, code = undefined): Promise<boolean> {
  this.loginError = '';
  this.isLoginLoading = true;

  try {
    
    if (exam) {
      return false;
    }
    this.loginComplete = false; // a new login starts; the widget waits until it completes

    let loginBody: any = { user, pw, inside: exam, code };

    try {
      const aliveData = await this.http.get('http://localhost:8088/alive').toPromise();
      if (aliveData?.['status'] === 'alive') {
        this.localServer = true;
        const whereamiData = await this.http.get('http://localhost:8088/whereami').toPromise();

        // LDAP login - for a typed username/password only. A one-time switch code (from appts,
        // aweb, ...) carries no credentials: sent down this branch it was discarded and the
        // connector was asked to authenticate an empty user, so arriving with a code on an
        // Active Directory machine always ended on a blank page. A code goes to /api/login below,
        // with the connector's location, so the server's location rule still applies.
        if (whereamiData?.['office_server'] && !code) {

          this.ldapLogin(user, pw, whereamiData, navigate);
          return true;
        }

        // Connector Installed
        if (whereamiData?.['location']) {
          loginBody.location = whereamiData['location'];
        }
      }
    } catch (error) {
      this.localServer = false;
    }

    this.cachedCredentials = { user, pw };
    this.twoFaAlternateMethod = null;
    this.triedTwoFaMethods.clear();
    if(loginBody.location) { // EXTEMRELY IMPORTANT , When CONNECTOR Exists, PASS IT TO cachedCreds!
    this.cachedCredentials.location = loginBody.location;
    }
    const loginRequest$ = this.http.post("/api/login", loginBody);
    const response:any = await loginRequest$.toPromise();
    // updateUser
    if (response?.state === 'requireUpdateInfo') {
      this.updateInfoRequired.next();
      return false;
    }
    // 2FA 
    if (response?.state === 'require_2fa') {
      this.twoFactorRequired.next();
      return false;
    } else {
      return await this.followLogin(of(response), navigate, user, isexport);
    }

  } catch (err) {
    this.loginError = code
      // The switch link is single-use and short-lived, and the server only accepts it from a
      // location this user may sign in from - say so instead of a bare "user not found".
      ? "This link could not sign you in to Cardio (it may have expired or already been used, or this location is not allowed to sign in). Please sign in."
      : err.error?.error || "An unexpected login error occurred.";
    // Tell the listeners: the patsearch/:code page waits for onLogin or onFailedLogin, and
    // without this it waited forever on a blank page. (followLogin already emits it for a
    // {status:'fail'} answer; this covers the HTTP errors - 401 and friends.)
    this.onFailedLogin.next(undefined);
    return false;
  } finally {
    this.isLoginLoading = false;
  }
}


  followLogin(req, navigate = true,user=null, isexport = false){
    this.clinicOptions = null;
    req.subscribe((data)=>{
      // A {status:'fail'} answer (e.g. the 2FA code could not be sent) carries no env, and
      // setEnv() below dereferences data.env first - it threw and aborted this callback before
      // the error was ever shown. Surface the error and stop here.
      if (data && data['status'] == 'fail') {
        if (data['twofaSendFailed']) this.handle2FASendFailure(data);
        else this.loginError = data['error'] || 'Login failed';
        this.contLogin = false;
        this.isLoginLoading = false;
        this.onFailedLogin.next(undefined);
        return;
      }
      if(data.hasOwnProperty("status") && data["status"] == "ok" && ! data.hasOwnProperty('code')){
        if(isexport){
          this.export$.next(this.exportData())
          return;
        }
        this.Clinic = null;
        if(data['Clinic']){
          this.Clinic = data['Clinic'];
          //try local server
          
        }    
        this.loginError = null;
        this.loginname = user;
        this.UID = data['uid'];
        this.username=data["uname"];
        this.LeumitAdmin = data['HMO'];
        this.totpVerify = data['TOTPSet'];
        this.isArtisanSupport = !!data['isArtisanSupport'];
        this.separatedClinic = false;
        if(data['hasSeparation'])
          this.separatedClinic = true;
        if(data['SeparateZimun'])
          this.SeparateZimun = true;
        else
          this.SeparateZimun=false;
        if(data['maccabi_exams'])
          this.maccabiExams = data['maccabi_exams'];
        else
          this.maccabiExams = null;
        this.macabiUnits = data['macabi_units'] && data['macabi_units'].length > 0 ? data['macabi_units'] : null;
        if(data["category"]){
          switch (data["category"]) {
            case "forms":
              this.category={
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:false
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:false
                },
                canSend: {
                  form:true,
                  exam:false
                },
                todayList: true
              }
              break;
              case "tech":
                this.category={
                  name: data["category"],
                  canOpen: {
                    form:true,
                    exam:true
                  },
                  canCreate:{
                    form:true,
                    exam:true
                  },
                  canChange:{
                    form:true,
                    exam:true
                  },
                  canSend: {
                    form:true,
                    exam:true
                  },
                  todayList: true
                }
                break;
            case "secretary":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:false,
                  exam:false
                },
                canCreate:{
                  form:false,
                  exam:false
                },
                canChange:{
                  form:false,
                  exam:false
                },
                canSend: {
                  form:false,
                  exam:true
                },
                todayList: true
              }
              break;
            case "nurse":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:false
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
            case "doctor":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;        
            default:
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
          }
        }
        this.getLimits();
        if(data["membership"])
          this.userType = data["membership"];  
        else{//no login
          if(data['env']['requiregroup']){
            this.loginError = "User is not authorized to use this system";
            return;
          }
          this.userType = 'doctor';//otherwise assume doctor
        }
        this.isAdmin = data['isAdmin'];
        this.finances = data['Finances'] || false;
        this.clinicUsers = data['users'];
        this.rooms=data['rooms']
        if(this.userType == 'doctor' && this.separatedClinic)
          this.doctor = this.UID;
        this.canOpenExams = data["openExams"];
        if(data['clinics']){
          this.clinicOptions = data['clinics'];
          this.filteredClinicSearch = this.clinicOptions; // add the fliteredOne
        }
        else{
          if (this.supportCenterEnabled) this.sc.getPending();
          this.onLogin.next(undefined);
          if(navigate)
            this.router.navigate(['/patsearch']);
        }
      }
      if(data.hasOwnProperty('letterhead'))
        this.letterhead = data['letterhead'];
      else
        this.letterhead = false;
    this.requireExamLogon = data['requireExamLogon'];
    this.setEnv(data);
    if(data['GID']){
      this.ClinicID = data['GID'];

        this.http.get(`/api/login/getTOS/${this.loginname}`).subscribe((data) => {
          this.premissions = data;
          this.onLoginComplete.next(null);
        })
    }
      if(data.hasOwnProperty('code')){
        this.getCode=true;
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
      this.contLogin = false;
      this.isLoginLoading = false;
    },(error)=>{
      this.isLoginLoading = false;
      this.loginError = error.error?.error || 'Login request failed.';
      console.error("Error in followLogin:", error);
      this.onFailedLogin.next();
    });
    return req
  }

  setEnv(data){
    this.ishospital = data['env']['ishospital'];
    if (data['env'] && 'supportCenterEnabled' in data['env']) {
      this.supportCenterEnabled = data['env']['supportCenterEnabled'] === true;
    }
    if(data["env"]){
      if( data["env"]["recording"]){
        this.Recording = data["env"]["recording"];
        if(data["env"]["webrtc"] == "remote"){
          this.RemoteRTC = true;
          this.PeerServ = data["env"]["peerServer"];
        }
      }
      if(this.ishospital ){
        this.premissions = data["env"]["premissions"]
        this.invasiveExams = this.hasPremission('ObstetricInvasive');
      }
      if(data['env']['hasTech'])
        this.hastech = data['env']['hasTech'];
      if(data['env']['bitRate'])
        this.bitRate = data['env']['bitRate'];
      if(data['env']['highBitrate'])
        this.highBit = data['env']['highBitrate'];
      if(data["env"]["AWL"])
        this.hasAWL = true;
      if(data["env"].hasOwnProperty("AWLOnlyExamOpening"))
        this.AWLOnlyExams = data["env"]['AWLOnlyExamOpening'];
      if(data["env"]["printLang"]){
        this.printLang = data["env"]["printLang"];
        this.pdf.Lang = data["env"]["printLang"];
      }
      if(data["env"]["printStyle"])
        this.printStyle = data["env"]["printStyle"];
      if(this.ishospital)
        this.RequireLoginToOpen = true;
      else{
        if(data["env"]["RequireLoginToOpen"])
          this.RequireLoginToOpen = data["env"]["RequireLoginToOpen"];
      }
      if(data["env"]["FullDelivery"])
        this.fullDelivery = data["env"]["FullDelivery"];
      if(data["env"]["AWLUnlimitedExams"])
        this.AWLUnlimited = data["env"]["AWLUnlimitedExams"];
      if(data["env"].hasOwnProperty('dopplerAutoOK'))
        this.dopplerAutoOk = data["env"]["dopplerAutoOK"];
      if(data["env"].hasOwnProperty("hasChameleon"))
        this.hasChameleon = data["env"]["hasChameleon"];
      if(data['env'].hasOwnProperty('hasFollicles'))
        this.hasFollicles = data['env']['hasFollicles'];
      if(data['env']['videoCodec'])
        this.VideoCodec = data['env']['videoCodec'];
      if(data['env']['archiveserv'])
        this.archiveServer = data['env']['archiveserv'];
      if(data['env']['anomaliesInSummary'])
        this.summaryOnlyAnamolies = data['env']['anomaliesInSummary'];
      if(data['env']['altNames'])
        this.anatomyAltNames = data['env']['altNames'];
      if(data['env']['defaultsButton'])
        this.defaultsButton = data['env']['defaultsButton'];
      if(data['env'].hasOwnProperty('smslink'))
        this.links = data['env']['smslink'];
      if(data['env'].hasOwnProperty('noprncheck'))
        this.PRNcheck = ! data['env'].noprncheck;
      if(data['env']['altSplash'])
        this.altSplashPage = data['env']['altSplash'];
      if(data['env']['hasEmergencyRoom'])
        this.hasEmergencyRoom = true;
      if(data['env']['awlExamNames'])
        this.AWLExamNames = data['env']['awlExamNames'];
      if(data['env']['altArchiveName'])
        this.altArchiveName = data['env']['altArchiveName'];
      if(data['env'].hasOwnProperty('measDefaultNone'))
        this.noneAsMeasDefault = data['env']['measDefaultNone'];
      if(data['env']['barcodeScan'])
        this.barcodeScan = data['env']['barcodeScan'];
      if(data['env']['examCodes'])
        this.ExamCodes = data['env']['examCodes'];
      if(data['env']['version'])
        this.APIversion = data['env']['version'];
    }
    if(data['Language']){
      this.printLang = data['Language'];
      this.pdf.Lang = data['Language'];
    }
    if(data.hasOwnProperty('hasLeumit'))
      this.hasLeumit = data.hasLeumit;
      this.isCardio = data.isCardio;
    // if(data['isCardio'])
    // else
    //   this.isCardio = false;
    if(data['isGastro'] || this.premissions)
      this.isGastro = this.premissions ? this.premissions.Gastro : data.isGastro
    else
      this.isGastro = false;
    if(this.isCardio && this.userType){
        switch(this.userType){
          case 'doctor':
            this.lastAwl = 'Completed';
          break;
          case 'tech':
            this.lastAwl = 'Received';
          break;
          case 'secretary':
            this.lastAwl = 'Waiting';
          break;
        }
    }
    this.ENVLoaded.next(undefined);
    this.hasENV = true;
  }

  sendCode(code: string){
    let req = this.http.get("api/logincode",{params:{"code": code}});
    req.subscribe((data)=>{
      if(data.hasOwnProperty("status") && data["status"] == "ok"){
        this.loginError = null;
        this.username=data["uname"];
        this.getCode=false;
        this.router.navigate(['/patsearch']);   
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
    },(error)=>{
      this.loginError = error.error.error;
    });
  }

  public getUserName(){
    return this.username
  }

  async loginAsCurrentUser(unSignExam: boolean = false, examId: any = "") {
    if (this.username && !this.requireExamLogon) {
      if (unSignExam) {
        (await this.signatureService.unSignExam(examId)).subscribe((data: Exam) => {
          this.signatureService.examUnSigned$.next(data);
          this.onLogin.next(undefined);
        });
      } else {
        this.onLogin.next(undefined);
      }
    }
  }

async ldapLogin(user: string, pw: string, serv: any, navigate = false) {
  
  const login$ = this.http.post<any>('http://localhost:8088/login', { login: user, 'pw': pw });

  try {
    const data = await login$.toPromise();

    if (data.hasOwnProperty("error")) {
      this.loginError = data["error"];
      return;
    }

    if (serv['location']) {
      data['location'] = serv['location'];
    }

    const remoteLogin$ = this.http.post('/remote/login', data);
    
    this.followLogin(remoteLogin$, navigate, user);

  } catch (err: any) {
    console.error(err);
    this.loginError = err.error?.error || "LDAP Login failed";
  }
}

  public getArchiveServer():string{
    return this.archiveServer;
  }

  public async Logout() {
    // The Support Center widget first: loginComplete gates its *ngIf, so clearing it destroys the
    // component (its ngOnDestroy disconnects); sc.reset() makes sure the socket is closed and no
    // previous-user chat survives in the root service.
    this.loginComplete = false;
    this.sc.reset();
    // The typed password was kept for the 2FA verify / resend; it must not outlive the session.
    this.cachedCredentials = null;
    this.twoFaAlternateMethod = null;
    this.triedTwoFaMethods.clear();
    (await this.clearCookies()).subscribe((data) => {
      this.router.navigate([""]);
      this.export$.next(false);
      this.totpVerify = false;
      this.room=null
    })
  }

  getRoomByRID(RID:number){
    for(let room of this.rooms){
      if(room.AutoIndex == RID)
        return room.RoomName;
    }
    return '';
  }
  
  async clearCookies() {
    return this.http.get("/api/login/clearCookies");
  }

  public canStartExam(hasawl: boolean):boolean{
    return this.canOpenExams && (this.ishospital || this.localServer) && (this.userType == 'doctor' || this.userType== 'tech') &&(! this.AWLOnlyExams ||  (this.AWLOnlyExams && hasawl));
  }

  public loginMissing(){
    if(! this.username)
      this.router.navigate(['/']);
  }

  public showAWL():boolean{
    return this.hasAWL && (! this.ishospital || this.userType == 'doctor' || this.userType == 'tech' || this.userType == 'secretary');
  }

  setClinic(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {

      const selectedGid = this.clinicOptions[id].GID;

      this.http.get('/api/setclinic/' + selectedGid).subscribe({
        next: (data: any) => {
          this.ClinicID = selectedGid;
          this.Clinic = this.clinicOptions[id].ClinicTitle;
          this.clinicUsers = data['users'];
          if (this.clinicOptions[id].MarginTop || this.clinicOptions[id].MarginBottom)
            this.letterhead = true;
          this.loginError = null;

          this.http.get(`/api/login/getTOS`).subscribe((tosData) => {
             this.premissions = tosData;
             this.onLoginComplete.next(null);

             if (this.isArtisanSupport) {
                // clinicOptions stays set: the login form keys off it, and it backs "Back to Clinics"
                this.getClinicUsers(selectedGid).subscribe({
                    next: (users) => {
                        this.usersList = users;
                        this.filteredUserSearch = users;
                        resolve(false);
                    },
                    error: (err) => {
                        this.loginError = "Failed to load clinic users";
                        reject(err);
                    }
                });
             } else {
                 this.clinicOptions = null;
                 if (this.supportCenterEnabled) this.sc.getPending();
                 this.onLogin.next(null);
                 this.router.navigate(['/patsearch']);
                 resolve(true);
             }
          });
        },
        error: (err) => {
          this.loginError = err;
          this.onFailedLogin.next(null);
          reject(err);
        }
      });
    });
  }
  // Unit for the Maccabi eligibility checks, remembered per clinic in this browser
  private savedMacabiUnit: {gid: any, code: string} = null;
  get macabiUnit(): string {
    if(! this.macabiUnits)
      return null;
    if(! this.savedMacabiUnit || this.savedMacabiUnit.gid != this.ClinicID){
      let code = null;
      try{ code = localStorage.getItem('macabiUnit_' + this.ClinicID); }catch(e){}
      this.savedMacabiUnit = {gid: this.ClinicID, code};
    }
    const code = this.savedMacabiUnit.code;
    return this.macabiUnits.some(u => u.code == code) ? code : this.macabiUnits[0].code;
  }

  set macabiUnit(code: string) {
    this.savedMacabiUnit = {gid: this.ClinicID, code};
    try{ localStorage.setItem('macabiUnit_' + this.ClinicID, code); }catch(e){}
  }

  getClinicUsers(gid: number) {
    return this.http.get<any[]>(`/api/admin/clinicUsers/${gid}`);
  }

async impersonateUser(uid: number) {
  this.isLoginLoading = true;

  const impersonate$ = this.http.post<any>('/api/login/impersonate', { uid: uid });

  try {

    const res = await impersonate$.toPromise();
    // followLogin's third argument becomes `loginname` - the name typed at a login prompt,
    // not the display name. The API sends both; `uname` is the fallback for an older API.
    this.followLogin(of(res), true, res.loginName || res.uname, false);

  } catch (err: any) {
    this.isLoginLoading = false;
    this.loginError = err.error?.error || "Impersonation failed";
  }
}
  getUserType(){
    return this.userType;
  }

  public hasPremission(name: string): boolean {
    return !! this.getPremission(name);
  }

  public getPremission(name: string): any {
    const p = Array.isArray(this.premissions) ? this.premissions[0] : this.premissions;
    return p ? p[name] : undefined;
  }

  saveHeader(formData){
    this.http.post(`/api/NewExams/setHeader/${this.CustomHeader.value ? 'y' : 'n'}`,formData).subscribe((data) => {
      console.log(data);
    })
  }

  getHeader(){
    this.http.get('/api/NewExams/getHeader' ).subscribe((data)=>{
      if(data['CustomLogo']){
        this.CustomHeader.patchValue(data['CustomLogo'])
      }
      if((data['PrintHeader'] || data['PrintHeaderCustom'] ) && ! this.ishospital && ! this.isCardio)
        this.getImageFromService();
    })
  }
  chaneHeader(){
    this.http.post('/api/NewExams/chageHeaderSetting', {CustomLogo: this.CustomHeader.value}).subscribe()
  }

  getImage(): Observable<Blob> {
    if(this.ishospital){
      if(this.CustomHeader.value){
        this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
      }else{
        this.headerToShow = `../../assets/images/clinic.jpg`
      }
      
    }else{
      if(this.CustomHeader.value){
        return this.http.get(`/api/NewExams/getImage/y`, { responseType: 'blob' });
      }else{
        return this.http.get(`/api/NewExams/getImage/n`, { responseType: 'blob' });
      }
    }
  }
  createImageFromBlob(image: Blob) {
    // this.headerToShow = this.sanitization.bypassSecurityTrustUrl(URL.createObjectURL(image))
    let reader = new FileReader();
    reader.addEventListener("load", () => {
       this.base64 = reader.result;
      // this.headerToShow = reader.result;
      this.headerToShow = this.sanitization.bypassSecurityTrustUrl(this.base64)

    }, false);
 
    if (image) {
       reader.readAsDataURL(image);
    }
 }
 getImageFromService() {
  this.isImageLoading = true;
  if(this.ishospital){
    if(this.CustomHeader.value){
      this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
    }else{
      this.headerToShow = `../../assets/images/clinic.jpg`
    }
  }
}

  exportData(){
    this.exportLoading = true;
    return this.http.get('/api/stats/exportdata')
  }

  getDocByUID(uid:number){
    for(let usr of this.clinicUsers){
      if(usr.UID == uid)
        return usr.Name;
    }
    return '';
  }

  getLimits(){
    this.http.get('/api/limits').subscribe((data) =>{
      this.limits = data;
    })
  }

  countLinks(){
    this.http.get('/api/NewExams/countLinks').subscribe((data:any) =>{
      this.linksent = data;
    })
  }

 async examLogin(user: string, pw: string,location?:boolean|string, isexport: boolean = false) {
    if(location) {
      location = this.cachedCredentials?.location;
    }

    const selectedGid = this.ClinicID;
    let params: any = { user, pw, location };
  
    // We add the selectedGid only In case its a multi clinic configuration..
    if (Array.isArray(this.filteredClinicSearch) && this.filteredClinicSearch.length > 0 && selectedGid) {
      params = { user, pw, location, selectedGid };
    }

    const loginRequest$ = this.http.post<any>('/api/login/examlogin', params); 
    try {
      const response = await loginRequest$.toPromise();

      this.followLogin(of(response), false, user, isexport);

    } catch(err) {
      this.loginError = err.error?.error || "An unexpected error occurred.";
    }
  }

  sendPasswordResetCode(username: string): Observable<any> {
    return this.http.post('/api/login/sendResetCode', { user: username });
  }  

  resetPassword(username: string, code: string, newPassword: string): Observable<any> {
    return this.http.post('/api/login/resetUserPW', { 
      user: username, 
      newPW: newPassword, 
      code: code 
    });
  }
  
   async completeLoginWith2FA(code: string, navigate = true) {
    if (!this.cachedCredentials) {
      // falls incase no login body params detected
      this.loginError = "Please enter your username and password again.";
      return;
    }

    const { user, pw , location } = this.cachedCredentials;

    const req = this.http.post("/api/login", { "user": user, "pw": pw, location, "twofacode": code });
    
    req.subscribe({
        next: (data:any) => { 
          if(data && data.error) {
            this.loginError = data.error;
            this.showTwoFactorInput = false;
          } else {
             this.followLogin(of(data), navigate, user);
          }
        },
        error: (err) => {
        // err.error is the parsed response BODY ({error, status} on a 401), not a string -
        // assigning it whole rendered "[object Object]" exactly when the user needs the reason.
        this.loginError =
          err?.error?.error ||
          (typeof err?.error === 'string' ? err.error : null) ||
          'An unexpected error occurred.';
      }                  
    })
  }
  // A code could not be sent. Say which channel failed and offer the other one if it has not
  // been tried; once both are exhausted twoFaAlternateMethod is null and the message points at
  // support.
  private handle2FASendFailure(data: TwoFaSendFailure) {
    const attempted = data['attemptedMethod'];
    const alternate = data['alternateMethod'];
    if (attempted) this.triedTwoFaMethods.add(attempted);
    const canTryAlternate = alternate && !this.triedTwoFaMethods.has(alternate);
    this.twoFaAlternateMethod = canTryAlternate ? alternate : null;
    this.loginError = this.compose2FASendError(attempted, this.twoFaAlternateMethod);
  }

  private compose2FASendError(attempted: string, alternate: string | null): string {
    const label = (m: string) => (m === 'sms' ? 'SMS' : 'WhatsApp');
    if (alternate)
      return (
        `We couldn't send your verification code by ${label(attempted)}. ` +
        `You can try ${label(alternate)} instead - or contact support if the problem continues.`
      );
    return (
      "We couldn't reach you by SMS or WhatsApp. " +
      'Please contact support so we can get you signed in.'
    );
  }

  // Re-send over the chosen channel. Success opens the 2FA panel; another failure re-runs the
  // handler, which then points at support instead of offering a button.
  retry2FAWith(method: 'sms' | 'whatsapp') {
    if (!this.cachedCredentials) {
      this.loginError = 'Please enter your username and password again.';
      return;
    }
    this.isLoginLoading = true;
    this.twoFaAlternateMethod = null; // hide the button while the attempt is in flight
    this.requestResend2FACode(method).subscribe({
      next: (res: Partial<TwoFaSendFailure> & { state?: string }) => {
        this.isLoginLoading = false;
        if (res?.state === 'require_2fa') {
          this.loginError = null;
          this.twoFactorRequired.next();
        } else if (res?.status === 'fail' && res?.twofaSendFailed) {
          this.handle2FASendFailure(res as TwoFaSendFailure);
        } else if (res?.error) {
          this.loginError = res.error;
        }
      },
      error: (err) => {
        this.isLoginLoading = false;
        this.loginError = err?.error?.error || "We couldn't send the code. Please contact support.";
      },
    });
  }

  requestResend2FACode(method: 'whatsapp' | 'sms'): Observable<any> {
    const { user , pw, location } = this.cachedCredentials;
    return this.http.post('/api/login', { 
      user: user, 
      pw: pw, 
      resend2FA: true,
      location: location,
      '2faMethod': method // method type (whatsapp or sms)
    });
  }

  // we are going to call this login route when using Code
  public async loginWithCode(code: string): Promise<boolean> {
  this.isLoginLoading = true;
  try {
    
    const loginRequest$ = this.http.post("/api/login", { code });
    
    return await this.followLogin(loginRequest$,false); // returns true/false on login

  } catch (error) {
    this.isLoginLoading = false;
    this.loginError = "An unexpected error occurred during login.";
    console.error(this.loginError, error);
    return false;
  } finally {
      this.isLoginLoading = false;
  }
} 
public async updateUserInfoAndProceed(updateInfo: { id: string, phone: string, email: string, authMode: string }) {
    this.loginError = ''; // Clear previous errors

    if (!this.cachedCredentials) {
      this.loginError = "Your session has expired. Please enter your username and password again.";
      throw new Error(this.loginError);
    }

    const { user, pw, location } = this.cachedCredentials;

    const payload = {
      user,
      pw,
      location,
      updateInfo
    };

    try {
      const response: any = await this.http.post("/api/login/updateInfo", payload).toPromise();

      if (response?.state === 'require_2fa') {
        this.twoFactorRequired.next();
      } else {
        // Case when user is not 2fa required
        await this.followLogin(of(response), true, user);
      }
    } catch (err) {
      // The HTTP request itself failed
      this.loginError = err.error?.error || "An unexpected error occurred while updating your information.";
      throw err;
    }
  }
}
